<template>
    <!-- Fila de configuración: etiqueta (y ayuda opcional) a la izquierda, BaseToggle a la derecha -->
    <div class="tw:flex tw:items-center tw:justify-between tw:gap-3"
        :class="{ 'tw:p-4 tw:bg-gray-50 tw:rounded-xl tw:border tw:border-gray-100': boxed }">
        <div class="tw:min-w-0">
            <label :for="id" class="tw:text-xs tw:font-semibold tw:text-gray-700 tw:block tw:cursor-pointer tw:m-0">
                <slot name="label">{{ label }}</slot>
            </label>
            <span v-if="hint || $slots.hint" class="tw:block tw:text-[11px] tw:text-gray-500">
                <slot name="hint">{{ hint }}</slot>
            </span>
        </div>
        <BaseToggle class="tw:shrink-0" :id="id" :value="value" :disabled="disabled" @input="$emit('input', $event)" />
    </div>
</template>

<script>
export default {
    name: 'BaseToggleRow',
    props: {
        value: { type: Boolean, default: false },
        // Id del checkbox; enlaza la etiqueta con el toggle
        id: { type: String, required: true },
        label: { type: String, default: '' },
        hint: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        // Muestra la fila dentro de una caja gris con borde
        boxed: { type: Boolean, default: false },
    },
}
</script>
